import {
  ExitPictureInPictureIcon,
  PictureInPictureIcon,
} from "../components/Icons";
import { useVideoPlayer2 } from "../hooks/use-video-player-2-setup-start";
import { useVideoPlayer2PictureInPicture } from "../hooks/use-video-player-helpers";

export function PictureInPictureButton() {
  const { isPictureInPicture, togglePictureInPicture } =
    useVideoPlayer2PictureInPicture();
  const player = useVideoPlayer2();

  return (
    <button
      className="video-player-2-btn video-player-2-picture-in-picture"
      onClick={togglePictureInPicture}
      title={
        isPictureInPicture
          ? player.trans("exitPictureInPicture")
          : player.trans("pictureInPicture")
      }
      aria-label={
        isPictureInPicture
          ? player.trans("exitPictureInPicture")
          : player.trans("pictureInPicture")
      }>
      {isPictureInPicture ? (
        <ExitPictureInPictureIcon />
      ) : (
        <PictureInPictureIcon />
      )}
    </button>
  );
}
